import produce from 'immer'

import * as types from 'Redux/Types/InboxTypes'

const initialState = {
  fetchingInboxEmails: false,
}

const fetchInboxEmails = (draft) => {
  draft.fetchingInboxEmails = true
}

const fetchInboxEmailsFailed = (draft) => {
  draft.fetchingInboxEmails = false
}

const fetchInboxEmailsSucceeded = (draft, { data, next, previous }) => {
  draft.fetchingInboxEmails = false
  draft.next = next
  draft.previous = previous
  draft.inboxEmails = data
}

const inboxReducer = (state = initialState, action) => {
  return produce(state, (draft) => {
    const { type, payload } = action

    switch (type) {
      case types.GET_INBOX_EMAILS:
        return fetchInboxEmails(draft)

      case types.GET_INBOX_EMAILS_FAILED:
        return fetchInboxEmailsFailed(draft)

      case types.GET_INBOX_EMAILS_SUCCEEDED:
        return fetchInboxEmailsSucceeded(draft, payload)

      // no default
    }
  })
}

export default inboxReducer
